import { z } from 'zod'

const formSchema = z.object({
  client_name: z.string().min(2, {
    message: 'Nombre de cliente debe tener al menos dos caracteres.',
  }),
  name: z.string().min(2, {
    message: 'Nombre de proceso debe tener al menos dos caracteres.',
  }),
  enrichment_type: z.number().int(),
  downloadable_types: z.array(z.number().int()).min(1, {
    message: 'Selecciona al menos un tipo de descargable.',
  }),
  level_a: z.number().int().min(1).max(3),
  level_b: z.number().int().min(1).max(3),
})

export { formSchema }
